import axios from "axios";
import { toast } from "react-toastify";
import history from "../..";
import {
  getJwt,
  getRefreshToken,
  removeToken,
  validarFechaExpiracionRefrehToken,
} from "../config/auth/credentialConfiguration";
import {
  AUTH_ENDPOINT_LOGIN,
  MSG_SISTEMA_NO_DISPONIBLE,
  MSG_SESION_EXPIRADA,
  TOAST_ID_MSG_SESION_EXPIRADA,
  AUTH_ENDPOINT_REFRESH_TOKEN,
  REQUEST_HEADER_CHANNEL,
} from "../infrastructure/appConstants";
import authService from "./authService";

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// To add token to the header with bearer schema
http.interceptors.request.use(
  (config) => {
    const token = getJwt();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    config.headers.channel = REQUEST_HEADER_CHANNEL;
    return config;
  },
  (error) => Promise.reject(error)
);

/*http.interceptors.response.use(undefined, (error) => {
  if (error.message === "Network Error" && !error.response) {
    toast.error("Tenemos un inconveniente, por favor intentelo nuevamente.");
  }

  const { status, config } = error.response;

  if (status === 404) {
    history.push("/notFound");
  }

  if (status === 401 && config && config.url !== AUTH_ENDPOINT_LOGIN) {
    // eslint-disable-next-line no-undef
    cerrarSesion();
  }

  if (status === 500) {
    toast.error("Server error - check the terminal for more info!");
  }

  throw error.response;
});*/

// Response interceptor for API calls
http.interceptors.response.use(
  (response) => {
    return response;
  },
  async function(error) {
    if (error.message === "Network Error" && !error.response) {
      toast.error(MSG_SISTEMA_NO_DISPONIBLE);
    }

    const originalRequest = error.config;
    if (
      error.response.status === 401 &&
      /* !originalRequest._retry && */
      originalRequest.url !== AUTH_ENDPOINT_LOGIN
    ) {
      originalRequest._retry = true;
      try {
        //Validando que el refresh token no hay expirado
        if (
          validarFechaExpiracionRefrehToken() &&
          (error.response.data.message !== "invalid_refresh_token" && error.response.data !== "")
        ) {
          await authService.refreshToken({
            refreshToken: getRefreshToken(),
          });
          return http(originalRequest);
        }else if(originalRequest.url === AUTH_ENDPOINT_REFRESH_TOKEN && error.response.status === 401){
          cerrarSesion();
        }else {
          cerrarSesion();
        }
      } catch (e) {
        cerrarSesion();
      }
    }

    const { status } = error.response;

    if (status === 404) {
      history.push("/notFound");
    }

    if (status === 500) {
      toast.error(MSG_SISTEMA_NO_DISPONIBLE);
    }

    throw error.response;
  }
);

const cerrarSesion = () => {
  removeToken();
  history.push("/login");
  toast.info(MSG_SESION_EXPIRADA, {
    toastId: TOAST_ID_MSG_SESION_EXPIRADA,
  });
};

const responseBody = (response) => response.data;

const request = {
  get: (url) => http.get(url).then(responseBody),
  post: (url, body) => http.post(url, body).then(responseBody),
  put: (url, body) => http.put(url, body).then(responseBody),
  delete: (url) => http.delete(url).then(responseBody),
  // Upload Files
  postForm: (url, file) => {
    // eslint-disable-next-line no-undef
    const formData = new FormData();
    formData.append("File", file);
    return http
      .post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(responseBody);
  },
  // Request: 'GET', allow Pagination on client
  getList: (url, params) =>
    http.get(url, { params }).then((res) => ({
      body: res.data,
      headers: res.headers,
    })),
};

export default request;
